import { DependencyList, useEffect } from 'react';

import { isEqual } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { getTransfers } from 'src/actions';
import { Transfer } from 'src/models';
import { CustomHookBaseOptions } from 'src/models/common.model';

import { useAccountSelector } from './useAccountSelector';
import { useTransferListSelector, UseTransferListSelectorReturnType } from './useTransferListSelector';

interface UseTransfersReturnType extends UseTransferListSelectorReturnType {}

interface UseTransfersOptions extends CustomHookBaseOptions {
  refetchOnChange?: boolean;
  queryParams?: {
    startDate?: string;
    endDate?: string;
    sortyBy?: 'ascending' | 'descending';
    states?: string;
  };
  dependency?: DependencyList;
}

export const useTransfers = ({
  skip,
  refetchOnChange,
  queryParams,
  dependency = [],
}: UseTransfersOptions): UseTransfersReturnType => {
  const dispatch = useDispatch();
  const transferListRaw: Transfer[] | undefined = useSelector((state: any) => state.cashiering.transfers?.data);
  const { transferList, isTransferListLoading, hasTransferListError, transferListError } = useTransferListSelector();
  const payload = useSelector((state: any) => state.cashiering.transfers?.payload);

  const { account } = useAccountSelector();

  const fetchList = () => {
    if (!account?.accountId) {
      return;
    }

    dispatch(getTransfers(account.accountId, queryParams));
  };

  useEffect(() => {
    if (skip) {
      return;
    }

    if (!transferListRaw && !isTransferListLoading && !hasTransferListError) {
      fetchList();

      return;
    }

    if (refetchOnChange || !isEqual(payload, { accountId: account?.accountId, queryParams })) {
      fetchList();
    }
  }, dependency);

  return {
    transferList,
    isTransferListLoading,
    hasTransferListError,
    transferListError,
  };
};
